import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-book-open-line text-lg text-white"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white tracking-wide">
                韩国漫画网
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              提供韩漫免费阅读和漫画在线服务，包含无遮韩国漫画大全。内容多样、操作简单，为您打造最佳的韩漫阅读体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">
              漫画分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-300 transition-colors whitespace-nowrap"
                  >
                    <i className={`${cat.icon} mr-1.5 text-xs`}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors"
                >
                  隐私政策
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors"
                >
                  使用条款
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>contact@koreancomic.cn</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                <span>北京市朝阳区漫画大厦12层</span>
              </li>
            </ul>
            <div className="flex gap-3 mt-5">
              <a
                href="https://weibo.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 rounded-full bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-sm text-white"></i>
              </a>
              <a
                href="https://weixin.qq.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 rounded-full bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors"
                aria-label="微信"
              >
                <i className="ri-wechat-line text-sm text-white"></i>
              </a>
              <a
                href="https://bilibili.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 rounded-full bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors"
                aria-label="B站"
              >
                <i className="ri-bilibili-line text-sm text-white"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 韩国漫画网 版权所有 | 京ICP备2026080123号-1
          </p>
          <p className="text-xs text-background-500">
            本站内容仅供学习交流使用，请勿用于商业用途
          </p>
        </div>
      </div>
    </footer>
  );
}